export function BoxArchiveLight({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      width={width}
      fill="none"
    >
      <path
        d="M32 64C14.3 64 0 78.3 0 96l0 32c0 17.7 14.3 32 32 32l16 0 0 256c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-256 16 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 64zM32 96l384 0 0 32L32 128 32 96zM80 416l0-256 288 0 0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 256c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z"
        fill="currentColor"
      />
    </svg>
  );
}
